import React from "react";
import TextInput from "../../core/TextInput";
import Checkbox from "../../core/Checkbox";

interface TagSearchProps {
  value: string;
  onChange: (value: string) => void;
  isAndSearch: boolean;
  onSearchTypeChange: (isAndSearch: boolean) => void;
  placeholder?: string;
  className?: string;
}

const TagSearch: React.FC<TagSearchProps> = ({
  value,
  onChange,
  isAndSearch,
  onSearchTypeChange,
  placeholder = "Ex. tag",
  className = "w-full",
}) => {
  return (
    <div className="flex flex-col gap-2">
      <TextInput
        onChange={onChange}
        placeholder={placeholder}
        value={value}
        className={className}
        widthClassName="w-full"
      />
      <p className="text-[12px] leading-4 text-gray-secondary">
        Separate tags with spaces or commas
      </p>
      <div className="flex items-center gap-2">
        <Checkbox
          id="tag-search-type"
          checked={isAndSearch}
          onCheckedChange={onSearchTypeChange}
        />
        <label 
          htmlFor="tag-search-type" 
          className="text-sm text-gray-600 cursor-pointer select-none"
        >
          Match all tags
        </label>
      </div>
    </div>
  );
};

// Helper function to format tags for server based on search type
// AND search: space-delimited
// OR search: comma-delimited
export const formatTagsForServer = (tags: string, isAndSearch: boolean): string => {
  if (!tags || tags.trim() === '') return '';
  
  // Split by comma or space to get individual tags
  const tagArray = tags.split(/[,\s]+/).filter(tag => tag.trim() !== '');
  
  if (tagArray.length === 0) return '';
  
  // Join with space for AND search, comma for OR search
  return isAndSearch ? tagArray.join(' ') : tagArray.join(',');
};

export default TagSearch;